
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/quiz/[id]",
      function () {
        return require("private-next-pages/pelatihan-mandiri/quiz/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/quiz/[id]"])
      });
    }
  